<button mat-icon-button [matMenuTriggerFor]="messagesMenu" (click)="openMessagesMenu()" #messagesMenuTrigger="matMenuTrigger">
    <mat-icon *ngIf="notifications.length > 0" matBadge="{{notifications.length}}" matBadgeColor="warn">person_add</mat-icon>
    <mat-icon *ngIf="notifications.length <= 0">person_add</mat-icon>
</button>
<mat-menu #messagesMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu messages">
    <span (mouseleave)="messagesMenuTrigger.closeMenu()">
        <mat-card class="content" [perfectScrollbar]="">
            <div fxLayout="column" fxLayoutAlign="none" *ngFor="let notification of notifications">
              <button mat-button (click)="navigation(notification)">
                <img src="{{notification.image != null?hostService.getHttpsImage()+notification.image:'assets/images/avatars/avatar-7.png'}}" width="50">   
                <div fxLayout="column" fxLayoutAlign="none" class="w-100">
                      <div fxLayout="row" fxLayoutAlign="space-between start">
                          <span class="name">{{notification.title}}</span>
                      </div>
                      <span class="text text-muted">{{notification.description}}</span>
                      <span class="info"><mat-icon>access_time</mat-icon> {{notification.date | date:'short'}}</span>
                  </div>
              </button>
            </div>             
        </mat-card>
    </span>
</mat-menu>